import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import OutlinedInput from "@mui/material/OutlinedInput";
import Typography from "@mui/material/Typography";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import SelectBox from "../../components/SelectBox";
import { useContext, useEffect } from "react";
import { ScreenStatusContext } from "../../context/ScreenStatusContext";

const infoTableCellSx = {
  fontSize: 18,
};

// 取引先情報表
export default function CustomerInfoEditTable(props) {
  const { customer } = props;

  // 画面ステータスをcontextから取得
  const {isChanged, setChanged} = useContext(ScreenStatusContext);

  // テキストボックス　フォーカス時に全選択する
  const onFocusInput = (event) => {
    event.target.select();
  };

  useEffect(() => {
    // 「列数」が２にする場合は「店舗表示」をまとめさせないこと
    if (customer.Value.orderFormColumnCountCd === 2)
      customer.handleChange(1, "orderFormShopSummaryCd");
  }, [customer.Value.orderFormColumnCountCd]);

  // 郵便番号フォーカスOFF時
  // const handleBlurPostCodeInput = (event) => {
  //   setCustomerInfoDataInput({
  //     ...customerInfoDataInput,
  //     post_code: event.target.value.replaceAll(/[^0-9]/g, ""),
  //   });
  // };

  // 番号フォーカスOFF時
  // const handleBlurNumberHyphenInput = (prop) => (event) => {
  //   setCustomerInfoDataInput({
  //     ...customerInfoDataInput,
  //     [prop]: event.target.value.replaceAll(/[^0-9\-]/g, ""),
  //   });
  // };

  // 入力変更時処理
  const onChangeCustomerInput = (value, prop) => (event) => {
    let valueChanged = customer.Value[prop] !== value;
    customer.handleChange(value, prop);
    setChanged(isChanged || valueChanged);
  }

  return (
    <TableContainer component={Box}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell width={180} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  取引先名&nbsp;
                </Grid>
                <Grid item xs="auto">
                  <Typography color="error">(必須)</Typography>
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <OutlinedInput
                onFocus={onFocusInput}
                onChange={(e) =>
                  onChangeCustomerInput(e.target.value, "customerName")(e)
                }
                value={customer.Value.customerName}
                sx={{ width: 400 }}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  ふりがな&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs="auto">
                  <OutlinedInput
                    onFocus={onFocusInput}
                    onChange={(e) =>
                      onChangeCustomerInput(
                        e.target.value,
                        "customerNameFurigana"
                      )(e)
                    }
                    value={customer.Value.customerNameFurigana}
                    sx={{ width: 600 }}
                  />
                </Grid>
                <Grid item xs>
                  <Typography fontSize={14}>ひらがなのみ</Typography>
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
          {/* <TableRow>
            <TableCell sx={infoTableCellSx}>郵便番号 </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs="auto">
                  <OutlinedInput
                    type="tel"
                    onFocus={onFocusInput}
                    // onChange={handleChangeInput("post_code")}
                    // onBlur={handleBlurPostCodeInput}
                    // value={"〒"+customerInfoDataInput.post_code}
                    inputProps={{ maxLength: 8 }}
                    sx={{ width: 100 }}
                  />
                </Grid>
                <Grid item xs>
                  <Typography fontSize={14}>半角数字のみ</Typography>
                </Grid>
              </Grid>
            </TableCell>
          </TableRow> */}
          <TableRow>
            <TableCell sx={infoTableCellSx}>住所</TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs="auto">
                  <OutlinedInput
                    onFocus={onFocusInput}
                    onChange={(e) =>
                      onChangeCustomerInput(e.target.value, "address")(e)
                    }
                    value={customer.Value.address}
                    sx={{ width: 400 }}
                  />
                </Grid>
                <Grid item xs>
                  <Typography fontSize={14}>半角数字のみ</Typography>
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>TEL</TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs="auto">
                  <OutlinedInput
                    type="tel"
                    onFocus={onFocusInput}
                    // onBlur={handleBlurNumberHyphenInput("tel")}
                    onChange={(e) =>
                      onChangeCustomerInput(e.target.value, "tel")(e)
                    }
                    value={customer.Value.tel}
                  />
                </Grid>
                <Grid item xs>
                  <Typography fontSize={14}>
                    半角数字, ハイフン(-)のみ
                  </Typography>
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>FAX</TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs="auto">
                  <OutlinedInput
                    type="tel"
                    onFocus={onFocusInput}
                    // onBlur={handleBlurNumberHyphenInput("fax")}
                    onChange={(e) =>
                      onChangeCustomerInput(e.target.value, "fax")(e)
                    }
                    value={customer.Value.fax}
                  />
                </Grid>
                <Grid item xs>
                  <Typography fontSize={14}>
                    半角数字, ハイフン(-)のみ
                  </Typography>
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>Email</TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs="auto">
                  <OutlinedInput
                    type="email"
                    onFocus={onFocusInput}
                    onChange={(e) =>
                      onChangeCustomerInput(e.target.value, "email")(e)
                    }
                    value={customer.Value.email}
                    sx={{ width: 400 }}
                  />
                </Grid>
                <Grid item xs>
                  <Typography fontSize={14}>半角英数記号のみ</Typography>
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>買人No.</TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs="auto">
                  <OutlinedInput
                    type="tel"
                    onFocus={onFocusInput}
                    // onBlur={handleBlurNumberHyphenInput("buyer_no")}
                    onChange={(e) =>
                      onChangeCustomerInput(e.target.value, "buyerNo")(e)
                    }
                    value={customer.Value.buyerNo}
                    sx={{ width: 100 }}
                  />
                </Grid>
                <Grid item xs>
                  <Typography fontSize={14}>
                    半角数字, ハイフン(-)のみ
                  </Typography>
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>

          {/* 出力形式 */}

          <TableRow>
            <TableCell sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  出力形式&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container alignItems="center" spacing={2}>
                <Grid item xs='auto'>
                  <SelectBox
                    label="列数・向き"
                    data={[
                      { value: "1列・縦向き", key: 1 },
                      { value: "1列・横向き", key: 3 },
                      { value: "2列・縦向き", key: 2 },
                    ].map((x) => {
                      return {
                        key: x.key,
                        value: x.value,
                      };
                    })}
                    onChange={(e) =>
                      onChangeCustomerInput(
                        e.target.value,
                        "orderFormColumnCountCd"
                      )(e)
                    }
                    value={customer.Value.orderFormColumnCountCd}
                    sx={{ width: 200 }}
                    nullable={false}
                  />
                </Grid>
                <Grid item xs='auto'>
                  <SelectBox
                    label="店舗表示"
                    data={[
                      { value: "1店舗ごと", key: 1 },
                      customer.Value.orderFormColumnCountCd !== 2 && {
                        value: "まとめる",
                        key: 2,
                      },
                    ].map((x) => {
                      return {
                        key: x.key,
                        value: x.value,
                      };
                    })}
                    onChange={(e) =>
                      onChangeCustomerInput(
                        e.target.value,
                        "orderFormShopSummaryCd"
                      )(e)
                    }
                    value={customer.Value.orderFormShopSummaryCd}
                    sx={{ width: 300 }}
                    nullable={false}
                  />
                </Grid>
                <Grid item xs='auto'>
                  <SelectBox
                    label="種別ごと改ページ"
                    data={[
                      { value: "する", key: 1 },
                      { value: "しない", key: 2 },
                    ].map((x) => {
                      return {
                        key: x.key,
                        value: x.value,
                      };
                    })}
                    onChange={(e) =>
                      onChangeCustomerInput(
                        e.target.value,
                        "orderFormProductTypePartitionCd"
                      )(e)
                    }
                    value={customer.Value.orderFormProductTypePartitionCd}
                    sx={{ width: 300 }}
                    nullable={false}
                  />
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
